<section class="customer-ratings text-center site-padding text-md-left">
  <div class="container-fluid">
    <div class="mb-5">
      <h2 class="site-title title-fonts text-center">Customer Testimonials</h2>
      <div class="text-center">
        <img src="/assets/images/title-decor.svg" width="100%" height="100%" class="img-decor-top" alt="247Invites">
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-md-12 col-12">
        <div class="row justify-content-center mt-3">
          <div class="col-md-12 owl-trending-video">
            <owl-carousel-o [options]="customOptions">
              <ng-template carouselSlide>
                <div class="outer-card">
                  <div class="card">
                    <div class="card-body">
                      <div class="ratings-start d-flex justify-content-center mb-3">
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                      </div>
                      <p class="mb-0 text-center">
                        Created a Birthday Invitation video from this website
                        and all my invitees liked the invitation video. Unique
                        templates at affordable cost. Very Supportive staff and so just say Love it!
                      </p>
                      <div class="d-flex justify-content-center review-rates align-items-center mt-4">
                        <div class="initial-avatar-ui bg-green">VP</div>
                        <div class="owner-name">Vijai Pidinti</div>

                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template carouselSlide>
                <div class="outer-card">
                  <div class="card">
                    <div class="card-body">
                      <div class="ratings-start d-flex justify-content-center mb-3">
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                      </div>
                      <p class="mb-0 text-center">
                        Very good service by 24Invites.. They deliver very good
                        quality works for very less price.. And also very user
                        friendly for a normal person also to customise the
                        video..
                      </p>
                      <div class="d-flex justify-content-center review-rates align-items-center mt-4">
                        <div class="initial-avatar-ui bg-orange">RK</div>
                        <div class="owner-name">Bharath Kumar</div>

                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template carouselSlide>
                <div class="outer-card">
                  <div class="card">
                    <div class="card-body">
                      <div class="ratings-start d-flex justify-content-center mb-3">
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                      </div>
                      <p class="mb-0 text-center">
                        Really nice interface, ease to make an invitation card.
                        Good templates and formats Thanks for quickly responding
                        on a query. Great customer service even on holidays :
                      </p>
                      <div class="d-flex justify-content-center review-rates align-items-center mt-4">
                        <div class="initial-avatar-ui bg-purple">SM</div>
                        <div class="owner-name">Srinivasa Mahant</div>

                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template carouselSlide>
                <div class="outer-card">
                  <div class="card">
                    <div class="card-body">
                      <div class="ratings-start d-flex justify-content-center mb-3">
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                      </div>
                      <p class="mb-0 text-center">
                        Wow it’s great! You can creat your own video within no
                        time.They have variety of options and worthy for the
                        price.
                      </p>
                      <div class="d-flex justify-content-center review-rates align-items-center mt-4">
                        <div class="initial-avatar-ui bg-orange">EP</div>
                        <div class="owner-name">Esp# Pharm.D</div>

                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template carouselSlide>
                <div class="outer-card">
                  <div class="card">
                    <div class="card-body">
                      <div class="ratings-start d-flex justify-content-center mb-3">
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                      </div>
                      <p class="mb-0 text-center">
                        Excellent service.. that too at an affordable price.
                        Plus the after sale service is also commendable. These
                        people were so helpful in helping with my twins’
                        birthday invitation Video. It was a hasslefree
                        experience with the whole customisation process. To all
                        the parents looking for a trustworthy service.. please
                        go for it… trust me.. you won’t be disappointed. Looking
                        forward to work more with these people!
                      </p>
                      <div class="d-flex justify-content-center review-rates align-items-center mt-4">
                        <div class="initial-avatar-ui bg-purple">RT</div>
                        <div class="owner-name">Rishu Tyagi</div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template carouselSlide>
                <div class="outer-card">
                  <div class="card">
                    <div class="card-body">
                      <div class="ratings-start d-flex justify-content-center mb-3">
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                      </div>
                      <p class="mb-0 text-center">
                        Wonderfull designs and beautiful work of art on website
                        is done. Pocket friendly as well. The customer support
                        is also brilliant. Loved the website as how quickly it
                        works. Got my invitation within 5 minutes and in HD
                        quality. Loved the invitation designs and graphics as
                        well. I Will surely recommend this to my friends and
                        family in future.
                      </p>
                      <div class="d-flex justify-content-center review-rates align-items-center mt-4">
                        <div class="initial-avatar-ui bg-green">AM</div>
                        <div class="owner-name">Abhishek Malhotra</div>

                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template carouselSlide>
                <div class="outer-card">
                  <div class="card">
                    <div class="card-body">
                      <div class="ratings-start d-flex justify-content-center mb-3">
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                      </div>
                      <p class="mb-0 text-center">
                        Best site for any kind of video or ecard invitation with
                        a reasonable price... Used the frozen template for
                        daughters birthday invite and it was amazing! Must
                        recommeded to anyone looking for video/ecard invitation
                        creation... Thanks to 247Invites team for all your
                        support!!!
                      </p>
                      <div class="d-flex justify-content-center review-rates align-items-center mt-4">
                        <div class="initial-avatar-ui bg-orange">NK</div>
                        <div class="owner-name">Nitin Kalamkar</div>

                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template carouselSlide>
                <div class="outer-card">
                  <div class="card">
                    <div class="card-body">
                      <div class="ratings-start d-flex justify-content-center mb-3">
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                      </div>
                      <p class="mb-0 text-center">
                        I have received a Video as expected, they have done
                        majority of the work on their demo videos, you guys just
                        have to fill-in your details accordingly and that's it.
                        Even their customer care is very helpful, Fully
                        satisfied 🙂
                      </p>
                      <div class="d-flex justify-content-center review-rates align-items-center mt-4">
                        <div class="initial-avatar-ui bg-purple">BR</div>
                        <div class="owner-name">Bunty Rohra</div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template carouselSlide>
                <div class="outer-card">
                  <div class="card">
                    <div class="card-body">
                      <div class="ratings-start d-flex justify-content-center mb-3">
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                      </div>
                      <p class="mb-0 text-center">
                        Awesome help and customization by 247 team for my
                        daughters birthday.. I am impressed about the work.
                        Thank you so much.
                      </p>
                      <div class="d-flex justify-content-center review-rates align-items-center mt-4">
                        <div class="initial-avatar-ui bg-green">CM</div>
                        <div class="owner-name">Chellarao M.</div>

                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template carouselSlide>
                <div class="outer-card">
                  <div class="card">
                    <div class="card-body">
                      <div class="ratings-start d-flex justify-content-center mb-3">
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                      </div>
                      <p class="mb-0 text-center">
                        Hi friends here I'll tell the use the birthday vedio
                        making website is used for me. Vedio making website is
                        quiet interesting and attractive video for creating
                        special vieos for any of ur closed person we can make
                        them impress also to surprise them I too have a got an
                        idea to create a video So I hv searched this website and
                        its amazing Concept.
                      </p>
                      <div class="d-flex justify-content-center review-rates align-items-center mt-4">
                        <div class="initial-avatar-ui bg-green">KS</div>
                        <div class="owner-name">Kethavath Shankar</div>

                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template carouselSlide>
                <div class="outer-card">
                  <div class="card">
                    <div class="card-body">
                      <div class="ratings-start d-flex justify-content-center mb-3">
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                      </div>
                      <p class="mb-0 text-center">
                        Fabulous team of 247Invites. They, on request made a
                        customized theme invite for my daughters 1st birthday. I
                        am highly impressed. Good work !!
                      </p>
                      <div class="d-flex justify-content-center review-rates align-items-center mt-4">
                        <div class="initial-avatar-ui bg-orange">SV</div>
                        <div class="owner-name">Sakshi Verma</div>

                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template carouselSlide>
                <div class="outer-card">
                  <div class="card">
                    <div class="card-body">
                      <div class="ratings-start d-flex justify-content-center mb-3">
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                      </div>
                      <p class="mb-0 text-center">
                        It was so easy to make and download … less than a min.
                        Video invitation turned out to be really nice and
                        presentable Highly recommended ❤️
                      </p>
                      <div class="d-flex justify-content-center review-rates align-items-center mt-4">
                        <div class="initial-avatar-ui bg-purple">AA</div>
                        <div class="owner-name">Ayesha Ayyub</div>

                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template carouselSlide>
                <div class="outer-card">
                  <div class="card">
                    <div class="card-body">
                      <div class="ratings-start d-flex justify-content-center mb-3">
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                      </div>
                      <p class="mb-0 text-center">
                        Very good service. High quality video creation is very
                        easy through 247Invites.
                      </p>
                      <div class="d-flex justify-content-center review-rates align-items-center mt-4">
                        <div class="initial-avatar-ui bg-green">RL</div>
                        <div class="owner-name">Renu Lavania</div>

                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template carouselSlide>
                <div class="outer-card">
                  <div class="card">
                    <div class="card-body">
                      <div class="ratings-start d-flex justify-content-center mb-3">
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                      </div>
                      <p class="mb-0 text-center">
                        Very good and really helpful team. Thank you
                      </p>
                      <div class="d-flex justify-content-center review-rates align-items-center mt-4">
                        <div class="initial-avatar-ui bg-purple">MV</div>
                        <div class="owner-name">Neharika Venugopal</div>

                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template carouselSlide>
                <div class="outer-card">
                  <div class="card">
                    <div class="card-body">
                      <div class="ratings-start d-flex justify-content-center mb-3">
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                      </div>
                      <p class="mb-0 text-center">
                        Created naming ceremony invitation and all loved
                        it.Unique templates.
                      </p>
                      <div class="d-flex justify-content-center review-rates align-items-center mt-4">
                        <div class="initial-avatar-ui bg-orange">MM</div>
                        <div class="owner-name">Mayuri Mane</div>

                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template carouselSlide>
                <div class="outer-card">
                  <div class="card">
                    <div class="card-body">
                      <div class="ratings-start d-flex justify-content-center mb-3">
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                      </div>
                      <p class="mb-0 text-center">
                        Templates are elegant with affordable prices.
                      </p>
                      <div class="d-flex justify-content-center review-rates align-items-center mt-4">
                        <div class="initial-avatar-ui bg-purple">SM</div>
                        <div class="owner-name">Srivalli Manayam</div>

                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template carouselSlide>
                <div class="outer-card">
                  <div class="card">
                    <div class="card-body">
                      <div class="ratings-start d-flex justify-content-center mb-3">
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                      </div>
                      <p class="mb-0 text-center">
                        Fabulous service. Recommend.
                      </p>
                      <div class="d-flex justify-content-center review-rates align-items-center mt-4">
                        <div class="initial-avatar-ui bg-green">KA</div>
                        <div class="owner-name">Kartik Arora</div>

                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template carouselSlide>
                <div class="outer-card">
                  <div class="card">
                    <div class="card-body">
                      <div class="ratings-start d-flex justify-content-center mb-3">
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                      </div>
                      <p class="mb-0 text-center">Easy and convenient.</p>
                      <div class="d-flex justify-content-center review-rates align-items-center mt-4">
                        <div class="initial-avatar-ui bg-orange">SS</div>
                        <div class="owner-name">Sanchit Sood</div>

                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template carouselSlide>
                <div class="outer-card">
                  <div class="card">
                    <div class="card-body">
                      <div class="ratings-start d-flex justify-content-center mb-3">
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                        <span class="material-icons text-orange247">
                          star
                        </span>
                      </div>
                      <p class="mb-0 text-center">Easy and convenient.</p>
                      <div class="d-flex justify-content-center review-rates align-items-center mt-4">
                        <div class="initial-avatar-ui bg-green">HG</div>
                        <div class="owner-name">Haribabu Ganja</div>

                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </owl-carousel-o>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>